module.exports = __webpack_public_path__ + "assets/icons/service_channel_24px.svg";